import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import actions from '../actions';

const { reset: resetCartItem } = actions.cart;
const { reset: resetOrder } = actions.order;
const { reset: resetOrderStep } = actions.orderStep;
const { reset: resetReceipt } = actions.receipt;
const { reset: resetInvoice } = actions.invoice;
const { reset: resetMember } = actions.member;

export default config => Component => {
  return connect(
    null,
    {
      resetCartItem,
      resetOrder,
      resetOrderStep,
      resetReceipt,
      resetInvoice,
      resetMember,
    }
  )(
    class extends React.PureComponent {
      static displayName = wrapDisplayName(Component, 'WithResetPos');

      resetPos = () => {
        const {
          resetCartItem,
          resetOrder,
          resetOrderStep,
          resetReceipt,
          resetInvoice,
          resetMember,
        } = this.props;

        resetCartItem();
        resetOrder();
        resetOrderStep();
        resetReceipt();
        resetInvoice();
        resetMember();
      };

      render() {
        return <Component {...this.props} resetPos={this.resetPos} />;
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/assist/withResetPos.js